import { render, staticRenderFns } from "./AdminJournal.vue?vue&type=template&id=584d99f7"
import script from "./AdminJournal.vue?vue&type=script&lang=js"
export * from "./AdminJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports